import CT from '@marketplace-ai/tags';
import { Button, FormActions } from '~/components';

const TAGS = CT.peerRefReq.form;

interface PendingRequestPromptProps {
  email: string;
  resending: boolean;
  onResend: () => void;
  onCancel: () => void;
}

// [MCV-1814] Shown in the request dialog when a request to this email is already
// pending. Nothing was created or sent; Resend re-sends the pending one.
export const PendingRequestPrompt = ({
  email,
  resending,
  onResend,
  onCancel,
}: PendingRequestPromptProps) => (
  <div>
    <p data-cy={TAGS.pendingExistsMsg} className="pb-5">
      {`A pending request already exists for ${email}. Resend it?`}
    </p>
    <FormActions>
      <Button
        type="button"
        colorVariant="secondary"
        cyTag={TAGS.cancelPendingBtn}
        onClick={onCancel}
        disabled={resending}
      >
        Cancel
      </Button>
      <Button type="button" cyTag={TAGS.resendPendingBtn} onClick={onResend} disabled={resending}>
        {resending ? 'Resending...' : 'Resend'}
      </Button>
    </FormActions>
  </div>
);
